function base64ToBlob(base64: string, contentType: string): Blob {
  const byteCharacters = atob(base64);
  const byteArray = new Uint8Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteArray[i] = byteCharacters.charCodeAt(i);
  }

  return new Blob([byteArray], { type: contentType });
}

export function downloadBase64File(
  base64: string,
  fileName: string,
  contentType: string,
) {
  let url: string | undefined;
  let downloadLink: HTMLAnchorElement | undefined;

  try {
    const blob = base64ToBlob(base64, contentType);
    url = URL.createObjectURL(blob);
    downloadLink = document.createElement("a");
    downloadLink.href = url;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
  } finally {
    if (downloadLink) {
      document.body.removeChild(downloadLink);
    }
    if (url) {
      URL.revokeObjectURL(url);
    }
  }
}
